export const TOGGLE_LINE_BANNER = 'TOGGLE_LINE_BANNER'

export const NO_SHOW_LS_KEY = (id) => `portfolio_line_banner_${id}`

export const LOCALE_PREFIX = 'components.Banners.components.LineBanner'
